import React, { Fragment } from "react";

import { func, string } from "prop-types";

import { countriesOptions } from "../../../../helpers/index";

import { TextFieldGroup, SelectListGroup } from "../../../../common/index";

const ManualAddress = ({
  handleChange,
  addressLine1,
  addressLine2,
  addressLine3,
  town,
  county,
  postcode,
  country,
  classes = "",
}) => (
  <Fragment>
    <div className={classes}>
      <label htmlFor="addressLine1">Address line 1</label>
      <TextFieldGroup
        classes="register_field"
        value={addressLine1}
        onChange={(e) => {
          handleChange("addressLine1", e.target.value);
        }}
      />
    </div>
    <div className={classes}>
      <label htmlFor="addressLine2">Address line 2</label>
      <TextFieldGroup
        classes="register_field"
        value={addressLine2}
        onChange={(e) => {
          handleChange("addressLine2", e.target.value);
        }}
      />
    </div>
    <div className={classes}>
      <label htmlFor="addressLine3">Address line 3</label>
      <TextFieldGroup
        classes="register_field"
        value={addressLine3}
        onChange={(e) => {
          handleChange("addressLine3", e.target.value);
        }}
      />
    </div>
    <div className={classes}>
      <label htmlFor="town">Town</label>
      <TextFieldGroup
        classes="register_field"
        value={town}
        onChange={(e) => {
          handleChange("town", e.target.value);
        }}
      />
    </div>
    <div className={classes}>
      <label htmlFor="county">County</label>
      <TextFieldGroup
        classes="register_field"
        value={county}
        onChange={(e) => {
          handleChange("county", e.target.value);
        }}
      />
    </div>
    <div className={`col-4 p-0 ${classes}`}>
      <label htmlFor="postcode">Postcode</label>
      <TextFieldGroup
        classes="register_field"
        value={postcode}
        onChange={(e) => {
          handleChange("postcode", e.target.value);
        }}
      />
    </div>
    <div className={classes}>
      <label htmlFor="country">Country</label>
      <SelectListGroup
        classes="register_field register_field-dropdown"
        options={countriesOptions}
        value={country}
        onChange={(e) => {
          handleChange("country", e.target.value);
        }}
      />
    </div>
  </Fragment>
);

ManualAddress.propTypes = {
  handleChange: func.isRequired,
  addressLine1: string.isRequired,
  addressLine2: string.isRequired,
  addressLine3: string.isRequired,
  town: string.isRequired,
  county: string.isRequired,
  postcode: string.isRequired,
  country: string.isRequired,
  classes: string,
};

export default ManualAddress;
